import type {ISiteAyar} from "@/model/site_ayar.ts";

export interface ISiteAyarDTO{
  l?: string[] | string;
  lt: [];
  cn: [];
  t: Record<string, string>;
  d: Record<string, string>;
  cl: [];
  ll: [];
}

export function mapSiteAyarDTOtoSiteAyar(siteAyarDTO: ISiteAyarDTO): ISiteAyar {
  return {
    // Geriye dönük uyum: eski API/cache tek string logo döndürebilir
    logo: Array.isArray(siteAyarDTO.l) ? siteAyarDTO.l : (siteAyarDTO.l ? [siteAyarDTO.l] : []),
    login_type: siteAyarDTO.lt,
    contact_number: siteAyarDTO.cn,
    title: siteAyarDTO.t,
    description: siteAyarDTO.d,
    country_list: siteAyarDTO.cl,
    language_list: siteAyarDTO.ll,
  };
}
